import { render } from "./ItemTypeOptionTable.vue?vue&type=template&id=183569f6&scoped=true"
import script from "./ItemTypeOptionTable.vue?vue&type=script&lang=js"
export * from "./ItemTypeOptionTable.vue?vue&type=script&lang=js"

import "./ItemTypeOptionTable.vue?vue&type=style&index=0&id=183569f6&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183569f6"]])

export default __exports__